import React, { useState } from 'react';
import './loading.css';

/**
 * Lazy image with shimmer placeholder and fade-in once loaded.
 * Prevents layout jump when width/height or aspectRatio is provided.
 */
const ImagePlaceholder = ({
  src,
  alt = '',
  className = '',
  imgClassName = '',
  cover = false,
  loading = 'lazy',
  decoding = 'async',
  onError,
  style,
  ...rest
}) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div
        className={`image-placeholder image-placeholder--error ${className}`.trim()}
        style={style}
      />
    );
  }

  return (
    <div className={`image-placeholder ${className}`.trim()} style={style}>
      {!loaded && <span className="image-placeholder__blur" aria-hidden="true" />}
      <img
        src={src}
        alt={alt}
        loading={loading}
        decoding={decoding}
        className={[
          'image-placeholder__img',
          cover ? 'is-cover' : '',
          loaded ? 'is-loaded' : '',
          imgClassName,
        ]
          .filter(Boolean)
          .join(' ')}
        onLoad={() => setLoaded(true)}
        onError={(event) => {
          setFailed(true);
          if (onError) onError(event);
        }}
        {...rest}
      />
    </div>
  );
};

export default ImagePlaceholder;
